"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _GridList = require("../GridList");

var _ChipStatus = require("../ChipStatus");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CatalogPageList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var pages = _ref.pages,
      cols = _ref.cols,
      showPageNum = _ref.showPageNum,
      pageNumDisabled = _ref.pageNumDisabled,
      showStatus = _ref.showStatus,
      onClickItem = _ref.onClickItem;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_GridList.ImageList, {
    tileData: pages,
    cols: cols,
    title: showPageNum && function (props) {
      return /*#__PURE__*/_react["default"].createElement(_GridList.PageNumField, _extends({
        defaultValue: props.page_num,
        disabled: pageNumDisabled
      }, props));
    },
    subtitle: showStatus && function (props) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          margin: "4px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatus, _extends({
        code: props.status
      }, props)));
    },
    onClickItem: onClickItem
  }));
});

var _default = CatalogPageList;
exports["default"] = _default;
CatalogPageList.defaultProps = {
  pages: [],
  cols: 2,
  showPageNum: false,
  pageNumDisabled: true,
  showStatus: false,
  onClickItem: function onClickItem(e) {
    console.log(e);
  }
};